import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import {
  CmsConfig,
  ConfigModule,
  I18nModule,
  provideDefaultConfig,
  UrlModule,
} from '@spartacus/core';
import {
  FormErrorsModule,
  GlobalMessageComponentModule,
  OutletModule,
  OutletRefModule,
  PageLayoutModule,
  PageSlotModule,
  SpinnerModule,
} from '@spartacus/storefront';
import { CheckoutOrderListModule } from '../../checkout/checkout-order-list/checkout-order-list.module';
import { CheckoutOrderSummaryModule } from '../../checkout/checkout-order-summary/checkout-order-summary.module';
import { CheckoutShipToRddModule } from '../../checkout/checkout-ship-to-rdd/checkout-ship-to-rdd.module';
import { OrderConfirmationComponent } from './order-confirmation.component';

@NgModule({
  declarations: [OrderConfirmationComponent],
  imports: [
    CommonModule,
    PageLayoutModule,
    OutletModule,
    OutletRefModule,
    PageSlotModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    UrlModule,
    I18nModule,
    FormErrorsModule,
    SpinnerModule,
    GlobalMessageComponentModule,
    CheckoutOrderListModule,
    CheckoutOrderSummaryModule,
    CheckoutShipToRddModule,
    ConfigModule.withConfig({
      cmsComponents: {
        orderConfirmationPOShipToRDDComponent: {
          component: OrderConfirmationComponent,
        },
      },
    } as CmsConfig),
  ],
  providers: [
    provideDefaultConfig(<CmsConfig>{
      cmsComponents: {
        orderConfirmationPOShipToRDDComponent: OrderConfirmationComponent,
      },
    }),
  ],
  exports: [OrderConfirmationComponent],
})
export class OrderConfirmationModule {}
